jQuery(document).ready(function ($) {

  const blocks = document.querySelectorAll('.block__course-filter');
  blocks.forEach(block => {

    const blockID = block.id;

    const form = document.querySelector('#' + blockID +  ' form');
    const formID = form.id;

    $( '#' + blockID + ".block__course-filter input" ).each(function() {
      updateInputs($(this))
    });

    let dropdowns = $('#' + blockID + ' .block__course-filter__filter .dropdown-menu');
    dropdowns.on('click', function (e) {
      // stop dropdown from closing on dropdown menu click
      e.stopPropagation();
    });

    setSelectedLabelToToggle($('#' + blockID + '.block__course-filter .dropdown-toggle.sort'));

    $('#' + blockID + ' input[name="sort"]').change(function () {
      setSelectedLabelToToggle($('#' + blockID + '.block__course-filter .dropdown-toggle.sort'));
    });

    $( '#' + blockID + ' input').change(function () {
      updateInputs($(this))
    });

    $('#' + blockID + '.block__course-filter .dropdown__delete').click(function () {
      let parent = $(this).closest(".dropdown");
      parent.find('input:checked').trigger('click');
      parent.find('.counter span').text('0');
      parent.find('.dropdown-toggle span').text('');
      parent.children('.dropdown-toggle').removeClass('checked');
      let price_parent = parent.children('.dropdown-menu.price');
      if(price_parent.length > 0) {
        let pricerange = $('#' + blockID + ' #pricerange');
        let min = pricerange.slider( "option", "min" );
        let max = pricerange.slider( "option", "max" );
        pricerange.slider( "option", "values", [ min, max ] );
        $('#' + blockID + " input[name=price_min]").val(min);
        $('#' + blockID + " input[name=price_max]").val(max);
        window.Alpine.evaluate($('#' + blockID + " input[name=price_min]")[0], 'selected.price_min = ' + min);
        window.Alpine.evaluate($('#' + blockID + " input[name=price_max]")[0], 'selected.price_max = ' + max);
        $('#' + blockID + " .dropdown-menu .price span.from").text(currencyFormatDE(min));
        $('#' + blockID + " .dropdown-menu .price span.to").text(currencyFormatDE(max));
      }
    });

    // let price_min_value = parseFloat($("input[name=price_min]").val());
    // let price_max_value = parseFloat($("input[name=price_max]").val());
    let price_min_value = 0;
    let price_max_value = 10000;
    $('#' + blockID + ".block__course-filter .dropdown-menu .price span.from").text(currencyFormatDE(price_min_value));
    $('#' + blockID + ".block__course-filter .dropdown-menu .price span.to").text(currencyFormatDE(price_max_value));

    let localStoragePriceMax;
    let localStoragePriceMin;
    if (localStorage.getItem(formID)) {
      let store = JSON.parse(localStorage.getItem(formID));
      if (store.price_max) {
        localStoragePriceMax = parseInt(store.price_max);
      }
      if (store.price_min) {
        localStoragePriceMin = parseInt(store.price_min);
      }
    }

    $( '#' + blockID + " #pricerange" ).slider(
      {
        range: true,
        step: 5,
        min: price_min_value,
        max: price_max_value,
        values: [localStoragePriceMin ? localStoragePriceMin : price_min_value, localStoragePriceMax ? localStoragePriceMax : price_max_value],
        create( event, ui ) {
          sliderFunc(blockID, event, localStoragePriceMin, localStoragePriceMax, true, price_min_value, price_max_value);
        },
        slide: function( event, ui ) {
          sliderFunc(blockID, event, ui.values[ 0 ], ui.values[ 1 ], false, price_min_value, price_max_value);
        }
      }
    );

    $('#' + blockID + ' .block__course-filter__filter__mobile__button').click(function () {
      $('#' + blockID + ' .block__course-filter__filter__mobile__wrapper').show();
      $('#' + blockID + ' .block__course-filter__filter__mobile__overlay').show();
      $('html').addClass('overflow-hidden');
    });

    $('#' + blockID + ' .block__course-filter__filter__mobile__close, .block__course-filter__filter__mobile__overlay__close').click(function () {
      $('#' + blockID + ' .block__course-filter__filter__mobile__wrapper').hide();
      $('#' + blockID + ' .block__course-filter__filter__mobile__overlay').hide();
      $('html').removeClass('overflow-hidden');
    });

  });

  function updateInputs(input) {
    let parent = input.closest(".dropdown");
    let counter = parent.find('input:checked').not('[data-ignore]').length;
    parent.find('.counter span').text(counter);
    parent.find('.dropdown-toggle span').text('('+counter+')');
    let time_period = parent.find('.dropdown-menu.time_period');

    if(counter > 0)  {
      parent.children('.dropdown-toggle:not(.sort)').addClass('checked');
    } else {
      parent.children('.dropdown-toggle:not(.sort)').removeClass('checked');
      parent.find('.dropdown-toggle span').text('');
    }

    if(time_period.length > 0) {
      let min = new Date(time_period.find("input[name='date_start']").attr('min'));
      let max = new Date(time_period.find("input[name='date_end']").attr('max'));

      if(Date.parse(time_period.find("input[name='date_start']").val()) > min ||
        Date.parse(time_period.find("input[name='date_end']").val()) < max) {
        parent.children('.dropdown-toggle').addClass('checked');
      } else {
        parent.children('.dropdown-toggle').removeClass('checked');
      }
    }
  }

  function sliderFunc(blockID, event, minValue, maxValue, isInit, price_min_value, price_max_value) {

    if (!isInit) {
      if ( ( minValue + 20 ) >= maxValue ) {
        return false;
      }

      $('#' + blockID + ".block__course-filter .dropdown-menu .price span.from").text(currencyFormatDE(minValue));
      $('#' + blockID + ".block__course-filter .dropdown-menu .price span.to").text(currencyFormatDE(maxValue));
      $('#' + blockID + ".block__course-filter input[name=price_min]").val(minValue);
      $('#' + blockID + ".block__course-filter input[name=price_max]").val(maxValue);

      window.Alpine.evaluate($('#' + blockID + " input[name=price_min]")[0], 'selected.price_min = ' + minValue);
      window.Alpine.evaluate($('#' + blockID + " input[name=price_max]")[0], 'selected.price_max = ' + maxValue);
    }

    if (isInit) {
      if((minValue && minValue != price_min_value) || (maxValue && maxValue != price_max_value)) {
        let pricerange = $('#' + blockID + " #pricerange");
        pricerange.closest('.dropdown').children('.dropdown-toggle').addClass('checked');
        pricerange.slider(
          "option",
          "values",
          [minValue ? minValue : pricerange.slider( "option", "min" ) , maxValue ? maxValue : pricerange.slider( "option", "max" ) ]
        );

        $('#' + blockID + ".block__course-filter .dropdown-menu .price span.from").text(currencyFormatDE(minValue));
        $('#' + blockID + ".block__course-filter .dropdown-menu .price span.to").text(currencyFormatDE(maxValue));
        $('#' + blockID + ".block__course-filter input[name=price_min]").val(minValue);
        $('#' + blockID + ".block__course-filter input[name=price_max]").val(maxValue);
      }
    } else {
      let pricerange = $('#' + blockID + " #pricerange");
      let min = pricerange.slider( "option", "min" );
      let max = pricerange.slider( "option", "max" );

      if(minValue > min || maxValue < max) {
        pricerange.closest('.dropdown').children('.dropdown-toggle').addClass('checked');
      } else {
        pricerange.closest('.dropdown').children('.dropdown-toggle').removeClass('checked');
      }
    }
  }

  function currencyFormatDE(num) {
    if (typeof num === 'undefined') {
      return '';
    }
    return (
      num
        .toFixed(2) // always two decimal digits
        .replace('.', ',') // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    ) // use . as a separator
  }

  function setSelectedLabelToToggle(button) {
    let selected = button.closest('.dropdown').find('input:checked + label').text();
    button.text(selected);
  }
});
